'use strict';

import {ngDepModel} from './ngdepmodel.js';

import {evlCriterionModel} from './evlcriterionmodel.js';
import {evlFieldModel} from './evlfieldmodel.js';
import {br} from './br.js';

export class gaamendmentChecklistDataModel extends ngDepModel
{

	questions = {};

	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}

	beforeSetup(data){

	}

	getApproved(name){
		switch(name){
			case 'coordinatorApproved':
			case 'lawyerApproved':
			case 'managerApproved':
				return this.getClassifValue(name, 'yesno');
		}
		return null;
	}

	isQInstruction(id){
		let q = this.questions[id];
		if(!q){
			return false;
		}
		if(!q.instruction || q.instruction === ''){
			return false;
		}
		return true;
	}

	getQuestion(id){
		if(typeof(this.questions[id]) === 'undefined'){
			return null;
		}
		return this.questions[id];
	}

	getQuestionValue(id){
		let q = this.questions[id];
		if(!q){
			return null;
		}
		if(q.value === ''){
			return '';
		}
		let classif = this.s('jsDataService').get('cfgClassif');
		let classifName = 'yesnonot';
		if(classif && typeof(classif[classifName]) !== 'undefined'){
			let v = this.s('$filter')('filter')(classif[classifName], {id: q.value}, true);
			if(v.length > 0){
				return v[0].title;
			}
		}
		return '';
	}

}
